import { render, staticRenderFns } from "./TabRetours.vue?vue&type=template&id=d8fc550e&"
import script from "./TabRetours.vue?vue&type=script&lang=js&"
export * from "./TabRetours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports